module.exports = __webpack_public_path__ + "img/Wordmark v2 - white.46668d94.png";